import React from 'react'
import { useHistory, useParams } from 'react-router-dom'

export default function InitialChoice() {
    const history = useHistory()
    const params = useParams<{ app_name: string }>()

    return (
        <div className="container-fluid mb-2">
            <div className="row">
                <div className="col">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <h2>Oodrive : signature électronique</h2>
                    </div>

                    <p className="text-muted mb-4">
                        Aucun paramétrage n'existe encore. Choisissez comment vous souhaitez configurer la signature électronique :
                    </p>

                    <div className="row">
                        <div className="col-md-5">
                            <div
                                className="card card-body text-center"
                                style={{ cursor: 'pointer', border: '2px solid #28a745' }}
                                onClick={() => history.push(`/interfaces/signatures/${params.app_name}/groupe`)}
                            >
                                <i className="fa fa-users fa-3x text-success mb-3"></i>
                                <h4>Paramétrer pour le groupe</h4>
                                <p className="text-muted mb-3">
                                    Un seul pool de crédits partagé par toutes les sociétés du groupe.
                                    Les connexions et la contre-signature peuvent être définies au niveau groupe
                                    avec des surcharges par société/site si besoin.
                                </p>
                                <button
                                    className="btn btn-success"
                                    onClick={(e) => {
                                        e.stopPropagation()
                                        history.push(`/interfaces/signatures/${params.app_name}/groupe`)
                                    }}
                                >
                                    Paramétrer pour le groupe
                                </button>
                            </div>
                        </div>

                        <div className="col-md-1 d-flex align-items-center justify-content-center">
                            <strong className="text-muted">OU</strong>
                        </div>

                        <div className="col-md-5">
                            <div
                                className="card card-body text-center"
                                style={{ cursor: 'pointer', border: '2px solid #007bff' }}
                                onClick={() => history.push(`/interfaces/signatures/${params.app_name}/create`)}
                            >
                                <i className="fa fa-building fa-3x text-primary mb-3"></i>
                                <h4>Paramétrer pour une société</h4>
                                <p className="text-muted mb-3">
                                    Chaque société gère ses propres crédits, connexions et paramètres
                                    de signature de manière indépendante.
                                </p>
                                <button
                                    className="btn btn-primary"
                                    onClick={(e) => {
                                        e.stopPropagation()
                                        history.push(`/interfaces/signatures/${params.app_name}/create`)
                                    }}
                                >
                                    Paramétrer pour une société
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
